// <s-slideshow> — steps a scroll-snap track with --prev / --next commands and keeps a "1 / 3" counter in sync.
class SSlideshow extends HTMLElement {
  #ac;
  #track;
  #counter;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    this.#track = this.querySelector('[data-track]');
    this.#counter = this.querySelector('[data-counter]');
    if (!this.#track) return;

    this.addEventListener('command', (event) => {
      if (event.command === '--next') this.#go(1);
      if (event.command === '--prev') this.#go(-1);
    }, { signal });

    this.#track.addEventListener('scroll', () => this.#update(), { signal, passive: true });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') this.#go(document.dir === 'rtl' ? -1 : 1);
      if (event.key === 'ArrowLeft') this.#go(document.dir === 'rtl' ? 1 : -1);
    }, { signal });

    // Reset to the first slide each time the surrounding dialog opens.
    const dialog = this.closest('dialog');
    dialog?.addEventListener('toggle', (event) => {
      if (event.newState === 'open') {
        this.#track.scrollTo({ left: 0, behavior: 'instant' });
        this.#update();
      }
    }, { signal });

    this.#update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  get #slides() {
    return [...this.#track.children];
  }

  get #index() {
    const width = this.#track.clientWidth || 1;
    return Math.round(Math.abs(this.#track.scrollLeft) / width);
  }

  #go(step) {
    const count = this.#slides.length;
    const next = (this.#index + step + count) % count;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#slides[next]?.scrollIntoView({ behavior: reduce ? 'instant' : 'smooth', block: 'nearest', inline: 'start' });
  }

  #update() {
    if (this.#counter) this.#counter.textContent = `${this.#index + 1} / ${this.#slides.length}`;
  }
}

if (!customElements.get('s-slideshow')) customElements.define('s-slideshow', SSlideshow);
